import { render } from "./CapsuleList.vue?vue&type=template&id=09472442&scoped=true"
import script from "./CapsuleList.vue?vue&type=script&lang=js"
export * from "./CapsuleList.vue?vue&type=script&lang=js"

import "./CapsuleList.vue?vue&type=style&index=0&id=09472442&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09472442"]])

export default __exports__